import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../Outsourced";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {FreeSpinsOutro} from "../runnerpresentations/freespin/FreesSpinOutro";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NormalWin} from "../runnerpresentations/maingame/win/NormalWin";
import {RevealXWays} from "../runnerpresentations/maingame/RevealXWays";
import {DoXNudge} from "../runnerpresentations/DoXNudge";
import {WinCountUp} from "../runnerpresentations/maingame/win/WinCountUp";

export class OutsourcedFreespinsWinPresentation implements FlowStatePresentation {
    private presentations:SimplePresentation[];

    constructor() {
        this.presentations = [
            new DoXNudge(),
            new RevealXWays(),
            new NormalWin(),
            new WinCountUp(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.updateWin(controller),
                                  () => {
                                      return !Outsourced.model.data.brokeTheBank &&
                                             Outsourced.model.data.nextMode != GameMode.NORMAL;
                                  },
                                  "UpdateWin"),
            new FreeSpinsOutro(),
            new BrokeBankPresentation(),
        ];
    }

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "WinRunner ");
    }

    private updateWin(controller:SimplePresentationRunnerController) {
        const winAmount = Outsourced.model.data.accumulatedRoundWin;
        Outsourced.keypadPlugin.setWin(winAmount,
            Outsourced.model.data.mode != GameMode.NORMAL ||
            Outsourced.model.data.nextMode != GameMode.NORMAL,
            Outsourced.isWinBelowStake());
        controller.finish();
    }
}